export const ide = {
  inActivityDisconnect: 'ide.lineage.inactivity.disconnect',
  errorDisconnect: 'ide.lineage.error.disconnect',
  netWorkChangeDisconnect: 'ide.lineage.networkChange.disconnect',
  switchVisualView: 'switch.between.summary.and.zoomIn',
  datasetLineage: `lineage.dataset.open`,
  pipelineLineage: `lineage.pipeline.open`
};
